/** @jsx jsx */
import { Button, Elevation, Intent } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import { css, jsx } from '@emotion/core';
import { useState, Fragment } from 'react';
import { useHistory } from 'react-router-dom';
import AppToaster from '../../../AppToaster';
import { ContentCard, ContentCardHeader } from '../../../components/ContentCard';
import EventCreateOverlay from '../components/EventCreateOverlay';
import EventList from '../components/EventList';
import EventListFilter from '../components/EventListFilter';
import EventListSorter from '../components/EventListSorter';

const EventListPage = () => {
  const history = useHistory();
  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);

  const onCreated = (modelId: string) => {
    AppToaster.success('Veranstaltung hinzugefügt!');
    history.push(`/events/${modelId}`);
  };

  return (
    <ContentCard elevation={Elevation.TWO} css={styles.list}>
      <EventCreateOverlay
        isOpen={isCreateDialogOpen}
        onSuccess={onCreated}
        onClose={() => setIsCreateDialogOpen(false)}
      />
      <ContentCardHeader
        leftElement={
          <Fragment>
            <EventListFilter />
            <EventListSorter />
          </Fragment>
        }
        rightElement={
          <Button
            text="Hinzufügen"
            icon={IconNames.ADD}
            intent={Intent.PRIMARY}
            css={styles.headerButton}
            onClick={() => setIsCreateDialogOpen(true)}
          />
        }
      />
      <EventList />
    </ContentCard>
  );
};

export default EventListPage;

const styles = {
  headerButton: css`
    margin-left: 10px;
  `,
  list: css`
    margin-bottom: 20px;
  `,
};
